export const SET_ADDON_EDIT_ID = 'set_addon_edit_id';
export const SET_ADDON_MAIN_FLYOUT = 'set_addon_main_flyout';
